import { TableState } from '@optimus-web/core';
import { GroupMember, StringFilterType, useRepositoryQuery, UserStatus } from '@mews-commander/data-access';

export const useUserGroupMembersQuery = (
    groupId: string,
    { pagination, sort, globalFilters, filters }: TableState<GroupMember>
) =>
    useRepositoryQuery('userGroups', 'getMembers', {
        groupId,
        pagination,
        ...(sort.fullName && {
            sort: {
                firstName: {
                    priority: 0,
                    order: sort.fullName.order,
                },
                lastName: {
                    priority: 1,
                    order: sort.fullName.order,
                },
            },
        }),
        ...(globalFilters.search && {
            globalSearchFilter: {
                value: globalFilters.search,
                filterType: StringFilterType.Contains,
            },
        }),
        ...(filters.status?.[0] && {
            statusFilters: filters.status[0].value as Array<UserStatus>,
        }),
    });
